import { cnMixSpace } from '@consta/uikit/MixSpace'
import { Tag } from '@consta/uikit/Tag'
import { Text } from '@consta/uikit/Text'
import { Tooltip } from '@consta/uikit/Tooltip'
import type { FC } from 'react'
import { useRef, useState } from 'react'

const cnBodyItemTag = cnMixSpace({ mR: '2xs' })

type ProjectCardProps = {
  items: string[]
}
const countVisibleTag = 3

export const ProjectCardTags: FC<ProjectCardProps> = ({ items = [] }) => {
  const anchorTagsOtherRef = useRef<HTMLButtonElement>(null)
  const [isOpenTooltipTags, setOpenTooltipTags] = useState(false)
  const countTag = items.length

  const handleOpenTooltipTags = () => {
    setOpenTooltipTags(prev => !prev)
  }

  return (
    <>
      {items.slice(0, countVisibleTag).map(label => (
        <Tag key={label} className={cnBodyItemTag} mode="info" label={label} size="s" />
      ))}

      {countTag > countVisibleTag && (
        <>
          <Tag
            ref={anchorTagsOtherRef}
            className={cnBodyItemTag}
            size="s"
            mode="check"
            checked={isOpenTooltipTags}
            label={`+${countTag - countVisibleTag}`}
            onChange={handleOpenTooltipTags}
          />

          <Tooltip
            size="s"
            direction="downCenter"
            anchorRef={anchorTagsOtherRef}
            isOpen={isOpenTooltipTags}
            onClickOutside={handleOpenTooltipTags}>
            <Text size="xs" view="primary" lineHeight="xs">
              {items.slice(countVisibleTag).join(', ')}
            </Text>
          </Tooltip>
        </>
      )}
    </>
  )
}
